<tds-header>
  <tds-header-hamburger
    (click)="mobileMenuAction()"
    aria-expanded="false"
    aria-haspopup="true"
  ></tds-header-hamburger>

  <tds-header-title>{{ appName }}</tds-header-title>

  <tds-header-dropdown slot="end" no-dropdown-icon class="user-dropdown">
    @if (userphoto()) {
    <img
      slot="icon"
      [src]="userphoto()"
      alt="User avatar"
      class="user-avatar"
      height="34"
      width="34"
    />
    } @else {
    <tds-icon slot="icon" name="profile"></tds-icon>
    }
    <tds-header-dropdown-list size="lg">
      <tds-header-dropdown-list-user [header]="username()" [subheader]="useremail()">
      </tds-header-dropdown-list-user>
      <tds-header-dropdown-list-item (click)="toggleTheme()">
        <a>
          @if (theme.isDark()) {
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
            <path
              d="M12 18a6 6 0 1 0 0-12 6 6 0 0 0 0 12Z"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path d="M12 2v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <path d="M12 20v2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <path
              d="M4.93 4.93l1.41 1.41"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M17.66 17.66l1.41 1.41"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path d="M2 12h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <path d="M20 12h2" stroke="currentColor" stroke-width="2" stroke-linecap="round" />
            <path
              d="M4.93 19.07l1.41-1.41"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M17.66 6.34l1.41-1.41"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          } @else {
          <svg viewBox="0 0 24 24" width="20" height="20" fill="none">
            <g transform="translate(-2 0)">
              <path
                d="M21 13.2A7.5 7.5 0 0 1 10.8 3 a6.9 6.9 0 1 0 10.2 10.2Z"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </g>
          </svg>
          }
          <div class="tds-u-pl1">{{ (theme.isDark() ? 'Claro' : 'Escuro') }}</div>
        </a>
      </tds-header-dropdown-list-item>
      <tds-header-dropdown-list-item (click)="logout()">
        <a>
          <tds-icon name="exit"></tds-icon>
          <div class="tds-u-pl1">Logout</div>
        </a>
      </tds-header-dropdown-list-item>
    </tds-header-dropdown-list>
  </tds-header-dropdown>

  <tds-header-brand-symbol slot="end">
    <a aria-label="Scania - red gryphon on blue shield"></a>
  </tds-header-brand-symbol>
</tds-header>
